import classNames from 'classnames';

interface IconProps {
    className?: string | null;
}

function Calendrier({ className = null }: IconProps) {
    return (
        <svg
            className={classNames([{ [className]: className !== null }])}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 242.5 244.65"
        >
            <defs>
                <filter
                    id="drop-shadow-calendrier"
                    x="0"
                    y="0"
                    width="242.5"
                    height="244.65"
                    filterUnits="userSpaceOnUse"
                >
                    <feOffset dx="5" dy="5" />
                    <feGaussianBlur result="blur" stdDeviation="0" />
                    <feFlood floodColor="#000" floodOpacity="1" />
                    <feComposite in2="blur" operator="in" />
                    <feComposite in="SourceGraphic" />
                </filter>
            </defs>
            <polyline
                points="155.32 148.35 181.62 143.43 237.5 134.49 185.47 101.74 225.73 55.28 164.82 63.64 165.8 2.17 124.51 47.72 85.75 0 83.4 61.44 23.03 49.8 60.69 98.33 60.26 98.18 0 110.35 53.32 140.96 14.98 189.02 75.5 178.19 77.02 239.65 116.42 192.46 157.09 238.57"
                fill="#f63"
                filter="url(#drop-shadow-calendrier)"
                stroke="#000"
                strokeMiterlimit="10"
                strokeWidth="2"
            />
        </svg>
    );
}

export default Calendrier;
